<template>
    <Search @setState="setState" :boardId="board.boardId" ></Search>
    <ul class="photo-board">
        <li class="photo-board__item" v-for="article in list">
            <router-link :to="`/${$store.getters.getLang}/${board.boardId}/view?boardNo=${board.boardNo}&articleNo=${article.articleNo}`">
                <div class="photo-board__item--img">
                    <img :src="`/displayFile.do?attachNo=${ article.attachBag.thumbs[0].attachNo }`" :alt="article.attachBag.thumbs[0].altValue || '이미지'" v-if="article.attachBag.thumbs?.length">
                    <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(article)}/mqdefault.jpg`" alt="이미지" v-else-if="article.linkUrl && article.linkUrl.indexOf('youtu') > -1">
                </div>
                <div class="photo-board__item__con">
                    <h3 class="title03">{{article.title}}</h3>
                    <p class="date" v-if="!hideDate">{{$commonUtils.timestampToDate(article.createdDt)}}</p>
                </div>
            </router-link>
        </li>
    </ul>
    <kr_Pagination :totCnt="totCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
</template>

<script>
import Search from '@/components/kr/common/SearchBox.vue'
import Pagination from '@/components/kr/common/Pagination.vue'

export default {
    computed: {
        hideDate() {
            const host = window.location.hostname;   
            const path = this.$route.path;          

            return (
                (host === 'aorta.eumc.ac.kr'   && path === '/kr/vascularStory/list') ||
                (host === 'ewhabrain.eumc.ac.kr' && path === '/kr/br_vascularStory/list')
            );
        }
    },
    components: {
        Search,
        Pagination
    },
    props: {
        boardInfo: ''
    },
    data() {
        return {
            board: {},
            list: '',
            pageList: '',
            // pageCount: window.innerWidth > 720 ? 10 : 5,
            pageCount: 5,
            totCnt: 0,

            // 게시글 parameter
            currentNum: this.$route.query.currentNum || 1,
            pageRow: 9,
            //검색 관련 parameter
            title: this.$route.query.title || '',
            content: this.$route.query.content || '',
            searchKeyword: this.$route.query.searchKeyword || '',

        }
    },
    watch: {
        $route(to, from) {
            // 동일 게시판 안에서 이동
            if (to.query != from.query && to.path == from.path) {
                if (Object.keys(to.query).length === 0) this.init()
                for (let i in this.$route.query) {
                    this[i] = this.$route.query[i]
                }

                this.getList()
            }
        },
        // 다른 게시판으로 이동
        boardInfo(oldVal, newVal) {
            this.init()
            this.getList()
        }
    },
    methods: {
        getList() {
            const boardNo = this.boardInfo.boardNo
            const params = {
                hospId: this.$store.getters.getHost,
                boardNo: boardNo,
                startIndex: this.currentNum,
                pageRow: this.pageRow,
                title: this.title,
                content: this.content,
                searchKeyword: this.searchKeyword,
            }
            this.axios.get(this.api.article.list + boardNo, {
                params: params
            })
                .then(res => {
                    this.list = res.data.list
                    this.board = res.data.board
                    this.totCnt = res.data.totCnt

                })
        },
        // 검색 emit
        setState(s, v, p) {
            this[p] = ''
            this.currentNum = 1
            this[s] = v
            this.goPage()
        },
        // pagination emit
        setNum(n) {
            this.currentNum = n
            this.goPage()
        },
        goPage() {
            const obj = { currentNum: this.currentNum, title: this.title, content: this.content, searchKeyword: this.searchKeyword };
            for (const key in obj) {
                if (obj[key] === null || obj[key] === '') {
                    delete obj[key];
                }
            }

            this.$router.push({ path: this.$route.path, query: obj });
        },
        // 데이터 초기화
        init() {
            this.currentNum = 1
            this.title = ''
            this.content = ''
            this.searchKeyword = ''
        }
    },
    mounted() {
        this.getList()
    },
}
</script>

<style scoped></style>